const adminPanelDictPT = {
  adminPanelSectionMain: "Principal",
  adminPanelSectionSales: "Vendas",
  adminPanelSectionCatalog: "Catálogo",
  adminPanelSectionFinance: "Financeiro",
  adminPanelSectionStorefront: "Loja e marketing",
  adminPanelUserLists: "Listas de usuários",
  adminPanelBanners: "Banners",
  adminPanelSearchMenu: "Buscar no menu",
  adminPanelNoMenuResults: "Nenhum item encontrado",
  adminPanelOpenMenu: "Abrir menu",
  adminPanelBeta: "Beta",
  adminPanelUseClassic: "Voltar para o admin clássico",
  adminPanelTryNew: "Experimentar o novo admin",
  adminPanelChooseTitle: "Qual versão do admin você quer usar?",
  adminPanelChooseSubtitle:
    "Estamos migrando o painel administrativo para um novo visual. As duas versões têm as mesmas funcionalidades.",
  adminPanelNewVersion: "Novo admin",
  adminPanelNewVersionDescription: "Visual moderno, menu organizado por área e busca rápida.",
  adminPanelClassicVersion: "Admin clássico",
  adminPanelClassicVersionDescription: "O painel de sempre, sem mudanças.",
  adminPanelChooseHint: "Sua escolha vale até você sair. Dá para trocar de versão a qualquer momento pelo botão no topo da tela.",

  // Home
  adminHomeNeedsAttention: "Precisa de atenção",
  adminHomeNeedsAttentionHint: "Pendências atuais, independentes do período selecionado",
  adminHomeAllClear: "Tudo em dia",
  adminHomePendingBankTransfers: "Transferências bancárias a confirmar",
  adminHomePendingOrders: "Pedidos com pendência",
  adminHomePendingWithdraws: "Saques em processamento",
  adminHomePendingBangood: "Pedidos Bangood não processados",
  adminHomePendingPhysicalStores: "Lojas físicas a verificar",
  adminHomeIndicators: "Indicadores",
  adminHomeCustomPeriod: "Período personalizado",
  adminHomeGroupRevenue: "Receita",
  adminHomeGroupOperation: "Operação",
  adminHomeGroupWithdraws: "Saques",
  adminHomeTotalUsers: "usuários no total",
  adminHomeTotalProducts: "produtos no total",

  // Listas de usuários
  adminUsersStatusAll: "Todos",
  adminUsersStatusActive: "Ativos",
  adminUsersStatusBlocked: "Bloqueados",
  adminUsersStatusCancelled: "Cancelados",
  adminUsersStatusFilter: "Filtrar por status",
  adminUsersSearchPlaceholder: "Buscar por nome, username, e-mail, telefone ou indicador",
  adminUsersCreatedBetween: "Data de cadastro",
  adminUsersClearFilters: "Limpar filtros",
  adminUsersResults: "resultado(s)",
  adminUsersUser: "Usuário",
  adminUsersContact: "Contato",
  adminUsersLoadError: "Não foi possível carregar os usuários.",
  adminUsersRetry: "Tentar novamente",
  adminUsersNoResults: "Nenhum usuário encontrado com esses filtros.",
  adminUsersEmpty: "Nenhum usuário cadastrado nesta lista.",

  // Listas e filas
  adminListCopy: "Copiar",
  adminListCopied: "Copiado!",
  adminListLoadError: "Não foi possível carregar a lista.",
  adminListNoResults: "Nenhum item encontrado com essa busca.",
  adminListEmpty: "Nenhum item nesta lista.",
  adminWithdrawDestination: "Destino",
  adminWithdrawNoPending: "Nenhum saque aguardando processamento.",
  adminBankTransferSearch: "Buscar por username ou plano",
  adminBankTransferPending: "pendente(s)",
  adminBankTransferNone: "Nenhuma transferência aguardando confirmação.",
  adminBankTransferConfirmMessage: "Confirmar o recebimento desta transferência e ativar o cadastro do usuário?",
  adminBankTransferAuthorized: "Transferência autorizada com sucesso!",

  // Pedidos e pendências
  adminOrdersOrder: "Pedido",
  adminOrdersItems: "item(ns)",
  adminOrdersAwaitingShipment: "Aguardando envio",
  adminOrdersSearchPlaceholder: "Buscar por nº do pedido, comprador, vendedor ou loja",
  adminPendingSearchPlaceholder: "Buscar por nº do pedido ou comprador",
  adminPendingDownloadReceipt: "Baixar comprovante",
  adminPendingConfirmMessage: "Confirmar que a transferência bancária deste pedido foi recebida?",
  adminWithdrawRequestedShort: "Solicitado",

  // Catálogo e formulários
  adminFormSave: "Salvar",
  adminFormTranslations: "Nome em cada idioma",
  adminFormRequired: "Campo obrigatório",
  adminFormImageHint: "Uma imagem, até {mb} MB",
  adminFormImageInvalid: "Escolha um arquivo de imagem.",
  adminFormImageChoose: "Escolher imagem",
  adminFormImageReplace: "Trocar imagem",
  adminFormImageKeepCurrent: "Manter a imagem atual",
  adminFormImageRemove: "Remover",
  adminFormImageDrop: "ou arraste a imagem para cá",
  adminCatalogCategories: "Categorias",
  adminCatalogSubcategories: "Subcategorias",
  adminCatalogEditCategory: "Editar categoria",
  adminCatalogEditSubcategory: "Editar subcategoria",
  adminCatalogEditBrand: "Editar marca",
  adminCatalogEditType: "Editar tipo",
  adminCatalogSaved: "Cadastro salvo com sucesso!",
  adminCatalogSearchName: "Buscar pelo nome em qualquer idioma",
  adminCatalogSearchSubcategory: "Buscar por subcategoria ou categoria",
  adminCatalogViewInStore: "Ver na loja",
  adminCatalogChooseCategory: "Escolha a categoria",
  adminCatalogKind: "Tipo de item",
  adminCatalogService: "Serviço",
  adminCatalogProduct: "Produto",
  adminCatalogChooseSubcategories: "Escolha as subcategorias",
  adminCatalogAddSubcategories: "Adicionar subcategorias",
  adminCatalogLinkedSubcategories: "Subcategorias já vinculadas",
  adminCatalogLinkHint: "Vínculos já existentes não podem ser removidos por aqui.",
  adminCatalogLinkFailed: "O cadastro foi salvo, mas algumas subcategorias não puderam ser vinculadas. Edite o item para tentar de novo.",
  adminProductsSearch: "Buscar por nº, título ou vendedor",

  // Relatórios
  adminReportsThisMonth: "Este mês",
  adminReportsLastMonth: "Mês passado",
  adminReportsThisYear: "Este ano",
  adminReportsExportPdf: "Exportar PDF",
  adminReportsOrdersCount: "Pedidos no período",
  adminReportsPlatformRevenue: "Receita da plataforma",
  adminReportsOnHoldCount: "em espera",
  adminReportsSearchOrders: "Buscar por nº, comprador, vendedor, CF/P.IVA ou status",
  adminReportsOrderShort: "Pedido",
  adminReportsPaymentMethods: "Formas de pagamento",
  adminReportsInvoices: "Faturas",
  adminReportsBuyerShort: "Comprador",
  adminReportsSellerShort: "Vendedor",
  adminReportsInvoicingOn: "Ligado",
  adminReportsInvoicingOff: "Desligado",
  adminReportsSubscriptionsCount: "Assinaturas no período",
  adminReportsTotalPaid: "Total pago",
  adminReportsSearchSubscriptions: "Buscar por nome, documento, endereço ou forma de pagamento",
  adminReportsWithdrawalsCount: "Saques no período",
  adminReportsSearchWithdrawals: "Buscar por nome, e-mail, PayPal ou IBAN",

  // Lojas físicas e Bangood
  adminStoresSearch: "Buscar por loja, responsável, endereço ou CF/P.IVA",
  adminStoresApproveShort: "Aprovar",
  adminStoresClose: "Fechar",
  adminStoresRejectHint: "O motivo será enviado ao responsável pela loja.",
  adminBangoodToProcess: "A processar",
  adminBangoodProcessed: "Processados",
  adminBangoodNoPending: "Nenhum pedido Bangood aguardando processamento.",

  // Endereços, inscrições pagas e integrações
  adminSubscriptionsSearch: "Buscar por nome, username ou plano",
  adminIntegrationsConfigured: "Configurado",
  adminIntegrationsNotConfigured: "Não configurado",
  adminIntegrationsLoadFailed: "Não foi possível carregar a configuração atual. Salvar vai substituí-la.",
  adminIntegrationsMetaDescription: "Envia os eventos da loja para o Pixel do Meta (Facebook e Instagram Ads).",
  adminIntegrationsGtmDescription: "Adiciona o contêiner do Google Tag Manager às páginas da loja.",
  adminIntegrationsGtmHint: "Código do contêiner, no formato GTM-XXXXXXX.",
  adminAddressMenu: "Endereços SendCloud",
  adminAddressUserHint: "Escolha o tipo e busque pelo nome, username, e-mail ou cidade.",
  adminAddressSearchUser: "Buscar usuário",
  adminAddressLoadingUsers: "Carregando usuários…",
  adminAddressSendcloud: "Endereço no SendCloud",
  adminAddressLoadingAddresses: "Carregando endereços…",
  adminAddressNotFound: "O endereço não aparece na lista?",
  adminAddressRegisterOnSendcloud: "Cadastrar no SendCloud",
  adminAddressLink: "Vincular endereço",
  adminAddressLinkTitle: "Vincular endereço",
  adminAddressConfirmMessage: "Vincular este endereço de remetente do SendCloud ao usuário?",
  adminAddressLinked: "Endereço vinculado com sucesso!",

  // Banners
  adminBannersNew: "Nova",
  adminBannersDesktop: "Desktop",
  adminBannersMobile: "Mobile",
  adminBannersRatio: "proporção",
  adminBannersApplyTo: "Aplicar em",
  adminBannersAllLanguages: "Todos os idiomas",
  adminBannersBothDevices: "desktop e mobile",
  adminBannersImages: "imagens",
  adminBannersVisible: "Visível na loja",
  adminBannersHidden: "Oculto",
  adminBannersPreview: "Prévia na loja",
  adminBannersRemoveMessage: "O banner será removido quando você salvar as alterações.",
  adminBannersSubDelayHint: "O mesmo tempo vale para os três sub banners.",
  adminBannersRatioHint: "Toda imagem escolhida passa por um recorte na proporção",
  adminBannersUnsaved: "Alterações não salvas",
  adminBannersAllSaved: "Tudo salvo",
  adminBannersSaving: "Salvando…",

  // Whitelabel
  subnetEditedSuccessfully: "Sub-rede editada com sucesso!",
  editSubnetData: "Editar dados da sub-rede",
  searchByUsernameNameOrEmail: "Busque por username, nome ou e-mail",
  selectManager: "Selecione um manager",
  noManagersFound: "Nenhum manager encontrado",
  adminWhitelabelActive: "Ativas",
  adminWhitelabelInactive: "Inativas",
  adminWhitelabelSearch: "Buscar por nome, descrição, dono ou ID",
  adminWhitelabelTheme: "Tema",
  adminWhitelabelVisualIdentity: "Identidade visual",
  adminWhitelabelFooter: "Rodapé da loja",
  adminWhitelabelFaviconHint: "Ícone que aparece na aba do navegador.",
  adminWhitelabelInvalidEmail: "Informe um e-mail válido.",
  adminWhitelabelThemeEmpty: "Informe ao menos um campo para personalizar.",
  adminWhitelabelThemeSaved: "Tema personalizado com sucesso!",
  adminWhitelabelThemeSaveError: "Erro ao personalizar o tema.",
  adminWhitelabelThemeLoadError: "Erro ao carregar o tema atual.",
};

export default adminPanelDictPT;
